import { useEffect, useState } from "react";
import { ProductViewModel } from "../../../../viewmodels/setup/myProducts/ProductViewModel";

import { useLocation } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../../../store/actions/index";

import {
  classNames,
  getLastItem,
  isSunDistribution,
  withRouter,
} from "../../../../shared/utility";

import ProductDetailsForm from "../../../../components/forms/setup/product/ProductDetailsForm";
import SimpleBanner from "../../../../components/SimpleBanner";
import ProductSpecSheet from "../../../../components/forms/setup/product/pdf/ProductSpecSheet";
import ProductRnd from "../productRnd/ProductRnd";
import EmptyModal from "../../../../components/modals/EmptyModal";
import ProductProcessStatusAssigned from "../../processStatus/ProductProcessStatusAssigned";

const tabs = [
  { name: "Product Details", href: "#" },
  { name: "Specs Sheet", href: "#" },
  { name: "Process Status", href: "#" },
  { name: "Product R&D", href: "#" },
];

function ProductScreen(props) {
  const { logout } = props;

  const [currentTab, setCurrentTab] = useState(0);

  const [sunDistribution, setSunDistribution] = useState(isSunDistribution());
  const displayedTabs = sunDistribution ? tabs.slice(0, 1) : tabs;
  useEffect(() => {
    setSunDistribution(isSunDistribution());
  }, []);

  const { pathname } = useLocation();
  const productId = getLastItem(pathname);

  const {
    allergensOptions,
    getAllergensForDropdown,
    getProduct,
    loading,
    product,
    setShowSimpleNotification,
    showSimpleNotification,
    updateProduct,
    unitOfMeasureOptions,
    getUnitOfMeasuresForDropdown,
    getProductTypes,
    productTypeOptions,
    emptyModal,
    setEmptyModelOpen,
  } = ProductViewModel(logout, productId);

  const onStartDependencides = async function () {
    getAllergensForDropdown();
    getUnitOfMeasuresForDropdown();
    getProduct();
    getProductTypes();
  };

  useEffect(() => {
    onStartDependencides();
  }, []);

  useEffect(() => {
    if (sunDistribution && currentTab !== 0) {
      setCurrentTab(0);
    }
  }, [sunDistribution, currentTab]);

  const renderComponent = (index) => {
    switch (index) {
      case 0:
        return (
          <div key={0} className="-mt-2 bg-white">
            {loading ? (
              "loading"
            ) : (
              <ProductDetailsForm
                allergensOptions={allergensOptions}
                product={product}
                actionCall={updateProduct}
                isEdit={true}
                unitOfMeasureOptions={unitOfMeasureOptions}
                productTypeOptions={productTypeOptions}
                isSunDistribution={sunDistribution}
              />
            )}
          </div>
        );

      case 1:
        return (
          <div key={1} className="-mt-2 bg-white">
            {loading ? "loading" : <ProductSpecSheet product={product} />}
          </div>
        );

      case 2:
        return (
          <div key={2}>
            <ProductProcessStatusAssigned
              productId={productId}
              logout={logout}
              addSnackbar={props.addSnackbar}
            />
          </div>
        );

      case 3:
        return (
          <div key={3} className="-mt-2 bg-white">
            {loading ? (
              "loading"
            ) : (
              <ProductRnd
                product={product}
                logout={logout}
                addSnackbar={props.addSnackbar}
              />
            )}
          </div>
        );

      default:
        return (
          <div key={1000} className="-mt-2 bg-white">
            Could not load page, please try again
          </div>
        );
    }
  };

  return (
    <div className="bg-gray-50">
      <SimpleBanner
        setShow={setShowSimpleNotification}
        showSimpleNotification={showSimpleNotification}
      />
      <header className="bg-white shadow sticky top-0 z-50 hide-for-print">
        <div className="max-w-7xl mx-auto py-4 px-4 flex items-center justify-between flex-wrap sm:flex-nowrap">
          <div className="flex px-4 sm:px-12">
            <h1 className="text-3xl font-bold text-gray-900">
              {loading ? "Loading..." : product.name_en}
            </h1>
          </div>
        </div>
      </header>
      <main>
        <div className="p-6">
          {/* Content starts here */}

          {/* tab here */}
          <div className="hide-for-print">
            <div className="sm:hidden">
              <label htmlFor="tabs" className="sr-only">
                Select a tab
              </label>
              <select
                id="tabs"
                name="tabs"
                className="block w-full  border-gray-300 rounded-md"
                defaultValue={displayedTabs[currentTab]?.name}
                onChange={(e) => {
                  const newIndex = displayedTabs.findIndex(
                    (tab) => tab.name === e.target.value
                  );
                  setCurrentTab(newIndex === -1 ? 0 : newIndex);
                }}
                disabled={sunDistribution}
              >
                {displayedTabs.map((tab, index) => (
                  <option key={index}>{tab.name}</option>
                ))}
              </select>
            </div>
            <div
              className={classNames(
                sunDistribution ? "hidden" : "hidden sm:block"
              )}
            >
              <nav
                className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                aria-label="Tabs"
              >
                {displayedTabs.map((tab, index) => (
                  <a
                    key={tab.name}
                    href={tab.href}
                    className={classNames(
                      index === currentTab
                        ? "text-gray-900"
                        : "text-gray-500 hover:text-gray-700",
                      index === 0 ? "rounded-l-lg" : "",
                      index === displayedTabs.length - 1 ? "rounded-r-lg" : "",
                      "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                    )}
                    aria-current={index === currentTab ? "page" : undefined}
                    onClick={() => setCurrentTab(index)}
                  >
                    <span>{tab.name}</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        index === currentTab
                          ? "bg-indigo-500"
                          : "bg-transparent",
                        "absolute inset-x-0 bottom-0 h-0.5"
                      )}
                    />
                  </a>
                ))}
              </nav>
            </div>
          </div>

          {/* {tab content starts below} */}
          <div className="px-4 py-6 sm:px-0">
            <div className="sm:col-span-9 py-5 border-b border-gray-200">
              {displayedTabs.map((item, index) =>
                index === currentTab ? renderComponent(index) : null
              )}
            </div>
          </div>
        </div>
      </main>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductScreen)
);
